import { Auth } from 'api';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { getEmail, getTempPassword } from 'store/user';
import useSignIn from './useSignIn';

const useConfirmSignUp = () => {
  const navigate = useNavigate();
  const signIn = useSignIn();
  const email = useSelector(getEmail);
  const tempPassword = useSelector(getTempPassword);
  const confirmSignUp = useCallback(
    async (code: string) => {
      if (!email) throw new Error('No email in store');
      await Auth.confirmSignUp(email, code);
      toast.success('Your email has been verified.');
      if (tempPassword) {
        try {
          await signIn(email, tempPassword);
        } catch (err) {
          toast.error('Please try signing in again.');
          navigate('/login');
        }
      } else {
        toast('Please sign in.');
        navigate('/login');
      }
    },
    [email, navigate, signIn, tempPassword],
  );
  return confirmSignUp;
};
export default useConfirmSignUp;
